import { motion } from "framer-motion";
import { Star, ExternalLink } from "lucide-react";
import { GOOGLE_REVIEWS_LINK } from "@/lib/config";

// Recensioni reali dei clienti (fonte: scheda Google).
// Aggiorna questo elenco con le recensioni fornite dal cliente.
const REVIEWS = [];

const Stars = ({ n = 5 }) => (
  <div className="flex gap-0.5">
    {Array.from({ length: 5 }).map((_, i) => (
      <Star key={i} size={16} className={i < n ? "text-brand-gold fill-brand-gold" : "text-gray-300"} />
    ))}
  </div>
);

export default function Reviews() {
  return (
    <section id="recensioni" className="py-24 md:py-32 bg-white border-t border-gray-100">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="max-w-2xl mb-14">
          <span className="text-brand-gold font-semibold tracking-[0.2em] uppercase text-sm">Recensioni</span>
          <h2 className="font-display text-4xl md:text-5xl font-extrabold text-brand-ink mt-4 mb-5">
            Cosa dicono i nostri clienti
          </h2>
          <p className="text-brand-slate/70 text-lg">
            La fiducia dei nostri clienti è la nostra migliore garanzia. Leggi le recensioni verificate sulla nostra scheda Google.
          </p>
        </div>

        {REVIEWS.length > 0 && (
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
            {REVIEWS.map((r, i) => (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.08 }}
                data-testid={`review-${i}`}
                className="bg-white rounded-2xl border border-gray-100 shadow-sm hover:shadow-xl transition-shadow p-7 flex flex-col"
              >
                <Stars n={r.stars} />
                <p className="text-brand-slate/75 leading-relaxed my-4 flex-1">"{r.text}"</p>
                <div className="font-display font-bold text-brand-ink">{r.author}</div>
              </motion.div>
            ))}
          </div>
        )}

        <div className="rounded-2xl bg-brand-ink p-8 md:p-10 flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="flex items-center gap-5">
            <div className="text-center">
              <div className="font-display text-5xl font-extrabold text-brand-gold leading-none">5,0</div>
              <div className="mt-1"><Stars n={5} /></div>
            </div>
            <div className="text-white">
              <div className="font-display text-xl font-bold">Recensioni su Google</div>
              <div className="text-white/60 text-sm">Ristrutturare Casa Napoli · clienti verificati</div>
            </div>
          </div>
          <a
            href={GOOGLE_REVIEWS_LINK}
            target="_blank"
            rel="noreferrer"
            data-testid="google-reviews-btn"
            className="inline-flex items-center gap-2 bg-brand-gold hover:bg-brand-goldDark text-brand-ink font-bold px-7 py-3.5 rounded-full transition-colors whitespace-nowrap"
          >
            Leggi le recensioni su Google
            <ExternalLink size={16} />
          </a>
        </div>
      </div>
    </section>
  );
}
